export type RaffleSortOption =
  | 'default'
  | 'recently_added'
  | 'expiring_soon'
  | 'tickets_remaining_asc'
  | 'tickets_remaining_desc'
  | 'ticket_price_asc'
  | 'ticket_price_desc'
  | 'floor_price_asc'
  | 'floor_price_desc';

export type RaffleTypeFilter = 'all' | 'live' | 'past';

export type EndDateQuickFilter = '' | '1H' | '6H' | '24H' | '7D' | '14D';

export interface RaffleFilterState {
  raffleType: RaffleTypeFilter;
  ticketPriceMin: number | null;
  ticketPriceMax: number | null;
  endDateWithin: EndDateQuickFilter;
}

export interface RaffleControlsState {
  searchQuery: string;
  sort: RaffleSortOption;
  filters: RaffleFilterState;
}

export const DEFAULT_FILTER_STATE: RaffleFilterState = {
  raffleType: 'all',
  ticketPriceMin: null,
  ticketPriceMax: null,
  endDateWithin: '',
};

export const DEFAULT_CONTROLS_STATE: RaffleControlsState = {
  searchQuery: '',
  sort: 'default',
  filters: DEFAULT_FILTER_STATE,
};
